import { Outlet, useLocation } from 'react-router-dom';

import { useSession } from '@hooks';
import { Calendar } from '@components';

export function MyCalendarPage() {
  const { account } = useSession();
  const { pathname } = useLocation();

  if (!account) {
    return null;
  }

  const variant =
    account.__typename === 'Spot'
      ? (pathname
          .split('/')
          .filter(Boolean)
          .find((segment) => ['booking', 'event'].includes(segment)) as 'booking' | 'event')
      : 'all';

  return (
    <>
      <Calendar accountId={account.id} variant={variant} />
      <Outlet />
    </>
  );
}
